import { Box, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material'
import type * as React from 'react'
import { useState } from 'react'
import type { ConversationIllustrationInfo } from '../interfaces/ConversationIf'
import { ConversationImageDelButton } from './ConversationImageDelButton'

type ConversationImageListProps = {
  editMode: boolean
  items: ConversationIllustrationInfo[]
  onDeleteImage: (id: string) => void
}

export const ConversationImageList: React.FC<ConversationImageListProps> = ({
  editMode,
  items,
  onDeleteImage,
}) => {
  const [hoveredId, setHoveredId] = useState<string | null>(null)
  const regexp = /(mov|.3gp|.mp4|.ts|.webm|.mkv)$/i

  const handleMouseEnter = (id: string) => {
    setHoveredId(id)
  }

  const handleMouseLeave = () => {
    setHoveredId(null)
  }

  return (
    <TableContainer>
      <Table>
        <TableBody>
          {items.map(row => (
            <Box
              key={row.illustration_id}
              style={{
                padding: '16px 0px 0px calc(50% - 53px)',
                border: 'none',
                position: 'relative',
              }}
            >
              <TableRow>
                <TableCell
                  onClick={() => {
                    onDeleteImage(row.illustration_id)
                  }}
                  onMouseEnter={() => handleMouseEnter(row.illustration_id)}
                  onMouseLeave={handleMouseLeave}
                  style={{
                    padding: '0px',
                    border: 'none',
                    position: 'relative',
                    lineHeight: '0',
                  }}
                >
                  {regexp.test(row.storage_path.split('?')[0]) ? (
                    <video
                      controls
                      src={row.storage_path}
                      style={{
                        width: '106px',
                        height: '183px',
                        objectFit: 'fill',
                      }}
                    />
                  ) : (
                    <img
                      src={row.storage_path}
                      alt={row.text}
                      style={{
                        width: '106px',
                        height: '183px',
                        objectFit: 'fill',
                      }}
                    />
                  )}
                  {editMode && hoveredId === row.illustration_id && (
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.2)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <ConversationImageDelButton
                        onClick={() => {
                          onDeleteImage(row.illustration_id)
                        }}
                      />
                    </Box>
                  )}
                </TableCell>
              </TableRow>
            </Box>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
